import React, { type FC, useCallback } from "react";
import { trackStarted, withPrefix } from "@tracking/tracking";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import {
  useTrackElement,
  useTracking,
  useTranslation,
} from "@edreamsodigeo/frontend-core";
import { ButtonWithLoading } from "@edreamsodigeo/prisma-design-system";

import { type SigninButtonProps } from "./contract";

const { SIGNIN } = screenNames;
export const SIGNIN_SUBMIT_BUTTON = `${SIGNIN}_submit_button`;
export const CLICKED_ID = `${SIGNIN}_click:email`;

const SigninButton: FC<SigninButtonProps> = ({ loading, onClick }) => {
  const { state } = useScreenState();
  const gaTrackingPrefix = state.gaTrackingPrefix || state.trackingPrefix;
  const clickTrackingRef = useTrackElement<HTMLButtonElement>(
    ["click"],
    withPrefix(CLICKED_ID, state.trackingPrefix),
  );
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const handleSubmit = useCallback(() => {
    trackStarted({
      trackEvent,
      isEmail: true,
      screen: SIGNIN,
      prefix: gaTrackingPrefix,
    });
    onClick();
  }, [onClick, gaTrackingPrefix, trackEvent]);

  return (
    <ButtonWithLoading
      id={SIGNIN_SUBMIT_BUTTON}
      ref={clickTrackingRef}
      fullWidth
      disabled={loading}
      loading={loading}
      onClick={handleSubmit}
    >
      {t("authentication.signin.submit")}
    </ButtonWithLoading>
  );
};

export default SigninButton;
